import { isNil, omitBy } from 'lodash';

import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/catalog/vendors/`;

export const QueryKey = (payload?: Payload) => ['v4', 'catalog', 'vendors', omitBy(payload, isNil)] as const;

export type Payload = {
    letter?: string;
    page?: number;
    size?: number;
    search?: string;
    sort?: {
        field: keyof Models.Catalog.Vendor.Item;
        direction: 'asc' | 'desc';
    };
};

export type Response = {
    total: number;
    items: Models.Catalog.Vendor.Item[];
};
